import { useMemo } from "react";
import { ModuleTypeFamily, ModuleTypeId } from "../../../types/DBTables";
import { UseFormReturn } from "react-hook-form";

import NumberEditor from "../../Global/Editors/NumberEditor";
import TextEditor from "../../Global/Editors/TextEditor";
import { useGlobalData } from "../../GlobalDataProvider";
import SelectEditor from "../../Global/Editors/SelectEditor";
import { IModuleRound, useRound } from "../../../modules/roundHandler";
import { useFieldArray } from "react-hook-form";
import { Button, Card, Col, Table } from "react-bootstrap";
import styles from "./RoundLokalerOchRum.module.css";
import { IModuleVentilationFTXochFTConfig, StickProv } from "../../../types/ModuleDatas";
import { Colors } from "../../../modules/Colors";
import { MapTooltip } from "../../../types/globalData";
import { nameof } from "../../Global/Utils";
import BFLNote from "../BFL/BFLNote";

interface IProps {
  module: IModuleRound;
  data: any;
  formHook: UseFormReturn;
}

const RoundLokalerOchRum = ({ module, data, formHook }: IProps) => {
  //const globalData = useGlobalData(); //Test GIT igen
  const roundHandler = useRound();

  const infoVärmesystem = useMemo(() => {
    const zonModules = roundHandler
      .getRoundData()
      ?.data.modules.filter((m) => (m.family === ModuleTypeFamily.VärmeSekundar || m.family === ModuleTypeFamily.VärmeEl) && m.moduleTypeId !== ModuleTypeId.VarmeSekundarSaknas);
    const luftBurenVärmeModules = roundHandler.getRoundData()?.data.modules.filter((m) => m.moduleTypeId === ModuleTypeId.VentilationFTX || m.moduleTypeId === ModuleTypeId.VentilationFT);

    const kylaModules = roundHandler.getRoundData()?.data.modules.filter((m) => m.moduleTypeId === ModuleTypeId.KylaVattenburet);
    const hasKomfortKyla = kylaModules && kylaModules.length > 0;

    const map: any = {};
    const mapFamily: any = {};

    const listVärmeSystem: string[] = [];
    const listZon: string[] = [];
    if (zonModules) {
      for (let i = 0; i < zonModules?.length; i++) {
        let mod = zonModules[i] as IModuleRound;
        //mod.moduleTypeId
        if (mod.data.betjäningsområde && mod.name) {
          map[mod.data.betjäningsområde] = mod.name;
          mapFamily[mod.data.betjäningsområde] = mod.family;
          listVärmeSystem.push(mod.name);
          listZon.push(mod.data.betjäningsområde);
        }
      }
    }

    if (luftBurenVärmeModules) {
      for (let i = 0; i < luftBurenVärmeModules?.length; i++) {
        let mod = luftBurenVärmeModules[i] as any;

        map[mod.name] = mod.name;
        mapFamily[mod.name] = mod.family;
        listVärmeSystem.push(mod.name);
        listZon.push(mod.name);
      }
    }

    return { map, mapFamily, listVärmeSystem, listZon };
  }, [roundHandler]);

  const allModules = roundHandler.getRoundData()?.data.modules;
  const harKyla = allModules && allModules.find((m) => m.moduleTypeId === ModuleTypeId.KylaVattenburet);
  const isSummer = roundHandler.getActiveRound()?.isSummer as boolean;

  const { control, reset, watch } = formHook;
  const { fields, append, remove } = useFieldArray({
    control,
    name: "stickprov",
  });

  const allValues = formHook.getValues();

  const ventilationModules = roundHandler.getRoundData()?.data.modules.filter((m) => m.family === ModuleTypeFamily.Ventilation);
  const listVentilationSystem = ventilationModules ? ventilationModules.map((m) => m.name) : [];
  const listVentilationSystemToTypeMap = ventilationModules
    ? ventilationModules.reduce((acc: any, m) => {
        acc[m.name] = m.moduleTypeId;
        return acc;
      }, {})
    : {};
  listVentilationSystem.unshift("");
  const jaNej = ["Ja", "Nej"];
  const altKomfort = ["God", "Acceptabel", "Okomfortabel"];

  const stickprov = watch("stickprov"); //detect if user changed zon on any row - In that case rerender with correct värmeSystem set.

  const stickprovGroups = {} as any;
  for (let i = 0; i < stickprov?.length; i++) {
    let row = stickprov[i] as any;

    if (row.värmeSystem !== infoVärmesystem.map[row.zon]) {
      row.värmeSystem = infoVärmesystem.map[row.zon];
      console.error("VärmeSystem uppdaterat för zon " + row.zon + " RESET shouldn't be called from here (Only from useEffect...)!");
      //formHook.reset(allValues); //rerender with updated data
    }

    if (!stickprovGroups[row.zon]) {
      stickprovGroups[row.zon] = {
        zon: row.zon,
        värmeSystem: infoVärmesystem.map[row.zon],
        modulFamilj: infoVärmesystem.mapFamily[row.zon],
        stickprovInfos: [],
        ärLuftburenVärme: row.ärLuftburenVärme,
      };
    }
    stickprovGroups[row.zon].stickprovInfos.push({ stickprov: row, index: i });
  }

  // {
  //   isSummer ? (
  //     <></>
  //   ) : (
  //     <div className="col-lg-12">
  //       <NumberEditor
  //         label="Inställningsvärde termostat"
  //         fieldName={nameof<IModuleVärmeEl>("termostatInställningsvärde")}
  //         tooltipId={nameof<MapTooltip>("VärmeEl_termostatInställningsvärde")}
  //         formHook={formHook}
  //         options={{
  //           validate: {
  //             required: (value: any) => (value || value === 0 ? undefined : "Måste anges"),
  //             min: (value: any) => (value && value < 10 ? "> 10 ℃" : undefined),
  //             max: (value: any) => (value && value > 25 ? "< 25 ℃" : undefined),
  //           },
  //         }}
  //       ></NumberEditor>
  //     </div>
  //   );
  // }

  return (
    <div>
      <div className="mb-3" style={{ maxHeight: 500, overflowY: "auto", overflowX: "hidden" }} key="d1">
        <div>
          {Object.keys(stickprovGroups).map((zon) => (
            <Card key={zon} className="mb-4">
              <Card.Header>
                {stickprovGroups[zon].zon} - {stickprovGroups[zon].värmeSystem}
                <div className="headerGroup">
                  <button
                    style={{ width: "11rem" }}
                    type="button"
                    className={"btn btn-success"}
                    onClick={() => {
                      const dbg = stickprovGroups[zon];

                      append({
                        zon: zon,
                        uppmättTemperatur: undefined,
                        uppmättTemperaturTilluft: undefined,
                        värmeSystem: infoVärmesystem.map[zon],
                        ventilationsSystem: stickprovGroups[zon].ärLuftburenVärme ? zon : undefined,
                        komfortKylaAktiv: undefined,
                        upplevdKomfort: undefined,
                        inställningsvärdeTermostat: undefined,
                        note: "",
                      });
                    }}
                  >
                    Lägg till mätpunkt
                  </button>
                </div>
              </Card.Header>
              <Card.Body>
                {stickprovGroups[zon].stickprovInfos.map((row: { stickprov: StickProv; index: number }, rowIndexInGroup: number) => (
                  <div key={rowIndexInGroup + ".1"}>
                    <div className="row">{"Mätpunkt " + row.index}</div>
                    <div className="row">
                      <input type="hidden" {...formHook.register(`stickprov.${row.index}.zon`)} />

                      <div className="col-lg-4  align-self-end">
                        <SelectEditor
                          className="displayBlock"
                          items={listVentilationSystem}
                          label="Betjänande ventilationssystem"
                          isDisabled={row.stickprov.ärLuftburenVärme}
                          showWhenIsDisabled={true}
                          formHook={formHook}
                          fieldName={`stickprov.${row.index}.` + nameof<StickProv>("ventilationsSystem")}
                          tooltipId={nameof<MapTooltip>("Lokaler_ventilationsSystem")}
                          options={{ required: "Måste välja betjänande ventilationssystem (" + zon + ")" }}
                        />
                      </div>
                      <div className="col-lg-4  align-self-end">
                        <NumberEditor
                          step={0.1}
                          label="Mätvärde i vistelse-zon (°C)"
                          formHook={formHook}
                          fieldName={`stickprov.${row.index}.` + nameof<StickProv>("uppmättTemperatur")}
                          tooltipId={nameof<MapTooltip>("Lokaler_uppmättTemperatur")}
                          options={{
                            validate: {
                              required: (v) => {
                                return !v ? "Måste fyllas i" : undefined;
                              },
                              lessThan: (v) => {
                                return parseFloat(v) >= 40 ? "Måste vara mindre eller lika med 40" : undefined;
                              },
                              greaterThan: (v) => {
                                return parseFloat(v) < 0 ? "Måste vara mer än 0" : undefined;
                              },
                            },
                          }}
                        />
                      </div>
                      <div className="col-lg-4  align-self-end">
                        <NumberEditor
                          step={0.1}
                          label="Mätvärde tilluftsdon (°C)"
                          isDisabled={
                            listVentilationSystemToTypeMap[row.stickprov.ventilationsSystem] === ModuleTypeId.VentilationFT ||
                            listVentilationSystemToTypeMap[row.stickprov.ventilationsSystem] === ModuleTypeId.VentilationFTX
                              ? false
                              : true
                          }
                          formHook={formHook}
                          fieldName={`stickprov.${row.index}.` + nameof<StickProv>("uppmättTemperaturTilluft")}
                          tooltipId={nameof<MapTooltip>("Lokaler_uppmättTemperaturTilluft")}
                          options={{
                            validate: {
                              required: (v) => {
                                return !v ? "Måste fyllas i" : undefined;
                              },
                              lessThan: (v) => {
                                return parseFloat(v) >= 40 ? "Måste vara mindre eller lika med 40" : undefined;
                              },
                              greaterThan: (v) => {
                                return parseFloat(v) < 0 ? "Måste vara mer än 0" : undefined;
                              },
                            },
                          }}
                        />
                      </div>
                    </div>
                    <div className="row" key={rowIndexInGroup + ".2"}>
                      {harKyla && (
                        <div className="col-lg-4">
                          <SelectEditor
                            className="displayBlock"
                            items={jaNej}
                            label="Komfortkyla aktiv"
                            formHook={formHook}
                            fieldName={`stickprov.${row.index}.` + nameof<StickProv>("komfortKylaAktiv")}
                            tooltipId={nameof<MapTooltip>("Lokaler_komfortKylaAktiv")}
                          />
                        </div>
                      )}

                      <div className="col-lg-4 ">
                        <SelectEditor
                          className="displayBlock"
                          items={altKomfort}
                          label="Upplevd komfort"
                          formHook={formHook}
                          fieldName={`stickprov.${row.index}.` + nameof<StickProv>("upplevdKomfort")}
                          tooltipId={nameof<MapTooltip>("Lokaler_upplevdKomfort")}
                        />
                      </div>

                      {stickprovGroups[zon].modulFamilj === ModuleTypeFamily.VärmeEl && !isSummer && (
                        <div className="col-lg-4">
                          <NumberEditor
                            label="Inställningsvärde termostat"
                            fieldName={`stickprov.${row.index}.` + nameof<StickProv>("inställningsvärdeTermostat")}
                            tooltipId={nameof<MapTooltip>("VärmeEl_termostatInställningsvärde")}
                            formHook={formHook}
                            options={{
                              validate: {
                                required: (value: any) => (value || value === 0 ? undefined : "Måste anges"),
                                min: (value: any) => (value && value < 10 ? ">= 10 ℃" : undefined),
                                max: (value: any) => (value && value > 30 ? "<= 30 ℃" : undefined),
                              },
                            }}
                          ></NumberEditor>
                        </div>
                      )}

                      <div className="col p-2 me-1 d-flex justify-content-end pt-4">
                        {stickprovGroups[zon].stickprovInfos.length > 1 && (
                          <Button style={{}} className="btn btn-warning" onClick={() => remove(row.index)}>
                            Ta bort rad
                          </Button>
                        )}
                      </div>
                    </div>
                    <div className="row" key={rowIndexInGroup + ".3"}>
                      <div className="input-group mt-1" style={{ minHeight: "86px" }}>
                        <label className="form-label w-100">
                          Anteckningat mätpunkt {row.index}
                          <TextEditor multiline={true} label={""} fieldName={`stickprov.${row.index}.` + nameof<StickProv>("note")} formHook={formHook} />
                        </label>
                      </div>
                    </div>

                    {rowIndexInGroup < stickprovGroups[zon].stickprovInfos.length - 1 && (
                      <div style={{ width: "100%", padding: "30px 0px" }} key={rowIndexInGroup + ".3"}>
                        <div style={{ width: "100%", border: "1px solid " + Colors.GrayMedium }}> </div>
                      </div>
                    )}
                  </div>
                ))}
              </Card.Body>
            </Card>
          ))}
        </div>
      </div>
      <BFLNote formHook={formHook} />
      {/* <div className="row" key="d2">
        <div className="col-lg-12">
          <TextEditor multiline={true} label={"Anteckningar"} fieldName={"note"} formHook={formHook} />
        </div>
      </div> */}
    </div>
  );
};

export default RoundLokalerOchRum;
